import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { RootState } from "../../../../models";

export const getWebdealsState = (state: RootState) => {
    const webdeals = _get(state, "webdeals.deals") || [];
    const filteredWebdeals = webdeals.filter((webdeal) => !_isEmpty(webdeal.additionalProducts.productNumbers));
    return filteredWebdeals;
};
